// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router' // Falls du deinen Router in ./router/index.js exportierst

const pinia = createPinia()

createApp(App)
  .use(router)
  .use(pinia)
  .mount('#app')